// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__16T5T","messages":"styles_messages__2PJRK","input":"styles_input__17bgh","state":"styles_state__1exaj"};